export function getDeviceInfo() {
  // Verifica se está no lado do cliente (navegador)
  if (typeof window === 'undefined') {
    return 'Desconhecido'
  }

  const userAgent = window.navigator.userAgent

  if (/iPhone/i.test(userAgent)) return 'iPhone'
  if (/iPad/i.test(userAgent)) return 'iPad'
  if (/Android/i.test(userAgent)) return 'Android'
  if (/Windows NT/i.test(userAgent)) return 'Windows'
  if (/Macintosh/i.test(userAgent)) return 'Mac'
  if (/Linux/i.test(userAgent)) return 'Linux'
  return 'Desconhecido'
}
